/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createPhi } from '../../factoriesAny.js';
export var phiDependencies = {
  BigNumberDependencies,
  createPhi
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesPhi.generated.js
// module id = null
// module chunks = 